/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-console: 0, no-var: 0 */
/* globals _, Highcharts, mp */

_.namespace(`mp.charts`, function(ns) {
  'use strict';

  var is_global_options_set = false;

  /**
     * isIncompleteInterval -- Returns true if the last time-period has not been completed
     *
     * @param {Hash} series A single series, in highcharts format
     * @param {Hash} an options hash.
     *      * (required) must include the 'unit' interval in miliseconds
     *        OR A string describing the interval ('hour', 'day', 'week', 'month')
     *      * "adjust_for_local_time" (default: true). This adjusts the estimation
     *        for local time.
     * @return {Boolean} true/false
     */
  ns.isIncompleteInterval = function(data, options) {
    options = options || {};
    var unit = options.unit;
    if (data && data.length > 0 && !_.isUndefined(unit)) {
      var time_interval;
      var last_point = data[data.length - 1];
      var last_date = _.isArray(last_point) ? last_point[0] : last_point.x;
      var date = new Date();
      var current_date = date.getTime();
      var timezone_offset = mp.report.globals.utc_offset;
      if (options.adjust_for_local_time) {
        // many dates passed in are in the local time of the browser.
        timezone_offset += date.getTimezoneOffset();
      }
      current_date = current_date + 60000 * timezone_offset;

      var current_interval = (current_date - last_date);

      if (_.isString(unit)) {
        var hour = 60 * 60 * 1000; //  miliseconds in an hour

        switch (unit.toLowerCase()) {
          case `hour`:
            time_interval = hour;
            break;
          case `day`:
            time_interval = 24 * hour;
            break;
          case `week`:
            time_interval = 7 * 24 * hour;
            break;
          case `month`:
            date = new Date(current_date); // change date to account for offset
            var start = new Date(date.getYear(), date.getMonth());
            var end = new Date(date.getYear(), date.getMonth() + 1);
            time_interval = (end.getTime() - start.getTime());
            break;
          default:
            console.log(`Err. Unknown interval: "` + time_interval + `"`);
            return false;
        }
      } else {
        time_interval = unit;
      }

      return current_interval < time_interval;
    } else {
      return false;
    }
  };

  var check_incomplete_path = function(options, event) {
    options = options || {};
    if (!_.isUndefined(options.unit)) {
      var single_series = event.options;
      single_series.isIncompletePath = ns.isIncompleteInterval(single_series.data, options);
    }
  };

    /**
     * A wrapper around the Highcharts.chart method. Used to unify
     * global options, use unified global tooltips, and to adjust
     * features like the incomplete (dotted line) feature.
     *
     * NOTE: This wrapper also modifies the call to the tooltip formatter
     * to add a reference to the opts Object when called. This is to
     * allow for unified tooltips. (see ./tooltips.js for details)
     *
     * @param chart_params [Object] The Highcharts params object
     * @param opts [Object] Options used in the wrapper for the tooltip,
     *     dotted lines, etc.
     * @param on_chart_ready [Function] A callback which is triggered when
     *     the chart is ready to be displayed
     *
     * @return A new Highcharts.Chart object
     */
  ns.chart = function(chart_params, opts, on_chart_ready) {
    var options = _.defaults(opts || {}, {
      unit: undefined,
      x_type: `datetime`,
      y_type: `default`,
      adjust_for_local_time: true,
      tooltip: {
        disabled: false,
      },
    });

    // ensure global options have been set
    ns.set_global_options();

    chart_params = $.extend(true, {}, chart_params, {
      chart: {
        events: {
          ...chart_params.events,
          addSeries: _.partial(check_incomplete_path, options),
        },
      },
      tooltip: {},
    });

    if (chart_params.series) {
      _.each(chart_params.series, function(single_series) {
        single_series.isIncompletePath = ns.isIncompleteInterval(single_series.data, options);
      });
    }

    return new Highcharts.Chart(chart_params, function(chart) {
      var tooltip_options = chart.tooltip.options;
      if (tooltip_options && tooltip_options.formatter) {
        var formatter = tooltip_options.formatter;
        tooltip_options.formatter = function(tooltip) {
          return formatter.call(this, tooltip, options);
        };
      }

      if (on_chart_ready) {
        on_chart_ready(chart);
      }
    });
  };

  /**
     * Sets page-wide global options. Its reccomended to only call this
     * once, at the beginning of page load.
     *
     * If this has not been called, creating a new chart with chart(..)
     * will ensure the default global options are called.
     *
     * @param options_name [String] The name of the global options you want
     *     to set. Options are currently: 'default_chart' and 'clean_chart'.
     *     (see ./options.js for complete list)
     */
  ns.set_global_options = function(options_name, additional_options) {
    if (is_global_options_set) {
      if (!_.isUndefined(options_name)) {
        console.warn(`Global Highcharts options have already been set.`);
      }
    } else {
      options_name = options_name || `default_chart`;
      Highcharts.setOptions(ns.options[options_name]);
      is_global_options_set = true;
    }

    if (!_.isUndefined(additional_options)) {
      Highcharts.setOptions(additional_options);
    }
  };

  /**
     * An array of colors used in our charts.
     */
  ns.nth_color = mp.utility.nth_color;
});

}.call(window));